<div class="container">
  <div class="row">
    <div class="col-md-6 offset-3 text-center" style="margin-top: 5%;">
      <h3> {{ 'TITLES.WELCOME_TO_LYNX' | translate }}</h3>
    </div>
  </div>
</div>


<div class="row card-group" style="padding: 20px" *ngIf="navigationOptions">
  <div class="col-3" style="padding-top: 15px;" *ngFor="let so of navigationOptions">
    <div class="card homeItems">
      <div align="center" style="padding-top: 15px">
        <h2><mat-icon style="color:black;display:inline-block;">{{so.sidebarIcon}}</mat-icon> {{so.sidebarText | translate}}</h2>
        <hr>
      </div>
      <div style="width: 100%" class="itemContainer">
        <div class="row card-group" style="margin-top:-10px;padding-left: 20px; padding-right: 20px;">
          <div class="col-3 items" *ngFor="let route of so.children">
            <a class="homeLinks" [routerLink]="[route.routerLink]" [routerLinkActive]="'is-active'"
              [routerLinkActiveOptions]="{ exact: route.exact }">
              <mat-icon class="homeIcons">{{route.sidebarIcon}}</mat-icon>
              <span class="homeText">{{ route.sidebarTitle | translate }}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>